// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0px;
  padding: 0;
  box-sizing: border-box;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer {
  margin: 20px;
  display: flex;
  justify-content: space-between;
  & ul {
    background: rgb(105 196 216);
    padding: 6px;
    width: 220px;
  }
}

input,
select,
textarea {
  background-color: #fff;
  border: 1px solid #d8dce6;
  border-radius: 6px;
  display: block;
  margin: 0;
  outline: none;
  padding: 6px 12px 4px;
  transition: all 0.1s ease-in-out;
  width: 100%;
  font-size: 14px;
  line-height: 24px;
  height: 48px;
  font-family: Inter;
  @media (max-width: 767px) {
    height: 36px;
  }
  &:focus {
    background-color: #fff;
    border-color: #c7a688ae;
    box-shadow: 0 0 0 0.2rem #d9b99c92;
    transition: all 0.1s ease-in-out;
  }
  &:focus::-webkit-input-placeholder {
    opacity: 0;
  }
}
textarea {
  height: auto;
}
label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
  margin-bottom: 0;
  margin-top: 0;
  padding-bottom: 10px;
  padding-top: 3px;
}
button {
  font-size: 16px;
  font-weight: 600;
  line-height: 56px;
  background-color: #3d70a1;
  color: #fff;
  border-radius: 4px;
  border: none;
  width: 100%;
  cursor: pointer;
  padding: 0 12px;
  font-family: Inter;
  &:hover{
    opacity: 0.8;
  }
  @media (max-width: 767px) {
    line-height: 40px;
    font-size: 14px;
  }
  &:disabled{
    opacity: 0.4;
  }
}
a {
  color: #4a4a4f;
}
.active {
  border-bottom: 4px solid #000;
}
.errorText {
  color: rgb(184, 3, 3);
  font-size: 12px;
  padding: 6px 0 2px;
  display: block;
}
.ReactModal__Overlay {
  z-index: 50;
}
:global(.swiper){
  width: 100% !important;
}
p, h1, h2, h3, h4, h5, h6{
  word-break: break-word;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B;IACE,4BAA4B;IAC5B,YAAY;IACZ,YAAY;EACd;AACF;;AAEA;;;EAGE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,gCAAgC;EAChC,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB;IACE,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,kCAAkC;IAClC,gCAAgC;EAClC;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB;IACE,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,YAAY;EACd;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB","sourcesContent":["* {\n  margin: 0px;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.footer {\n  margin: 20px;\n  display: flex;\n  justify-content: space-between;\n  & ul {\n    background: rgb(105 196 216);\n    padding: 6px;\n    width: 220px;\n  }\n}\n\ninput,\nselect,\ntextarea {\n  background-color: #fff;\n  border: 1px solid #d8dce6;\n  border-radius: 6px;\n  display: block;\n  margin: 0;\n  outline: none;\n  padding: 6px 12px 4px;\n  transition: all 0.1s ease-in-out;\n  width: 100%;\n  font-size: 14px;\n  line-height: 24px;\n  height: 48px;\n  font-family: Inter;\n  @media (max-width: 767px) {\n    height: 36px;\n  }\n  &:focus {\n    background-color: #fff;\n    border-color: #c7a688ae;\n    box-shadow: 0 0 0 0.2rem #d9b99c92;\n    transition: all 0.1s ease-in-out;\n  }\n  &:focus::-webkit-input-placeholder {\n    opacity: 0;\n  }\n}\ntextarea {\n  height: auto;\n}\nlabel {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 16px;\n  margin-bottom: 0;\n  margin-top: 0;\n  padding-bottom: 10px;\n  padding-top: 3px;\n}\nbutton {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 56px;\n  background-color: #3d70a1;\n  color: #fff;\n  border-radius: 4px;\n  border: none;\n  width: 100%;\n  cursor: pointer;\n  padding: 0 12px;\n  font-family: Inter;\n  &:hover{\n    opacity: 0.8;\n  }\n  @media (max-width: 767px) {\n    line-height: 40px;\n    font-size: 14px;\n  }\n  &:disabled{\n    opacity: 0.4;\n  }\n}\na {\n  color: #4a4a4f;\n}\n.active {\n  border-bottom: 4px solid #000;\n}\n.errorText {\n  color: rgb(184, 3, 3);\n  font-size: 12px;\n  padding: 6px 0 2px;\n  display: block;\n}\n.ReactModal__Overlay {\n  z-index: 50;\n}\n:global(.swiper){\n  width: 100% !important;\n}\np, h1, h2, h3, h4, h5, h6{\n  word-break: break-word;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
